import { combineEpics, ofType } from "redux-observable";
import { concatMap, EMPTY, filter, from, map, mergeMap, of, switchMap, tap, withLatestFrom } from "rxjs";
import { setCatalogType } from "../../../store/calculation/calculation-input/TubingSlice";
import * as surfaceSer from "../../../../src/services/calculations/calculation-output/surfaceEquipment.service";
import * as SurfaceActions from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";
import * as CalculationActions from "../../../store/calculation/calculationSlice";
import { RootState, store } from "../../../store/ConfigureStore";
import { HarmonicFilterInstallationType, HarmonicFiltersFilterCriterias } from "../../../store/model/calculations/calculation";
import { calculateMotorLoadFrequency } from "../../../store/calculation/calculationSlice";
import { setTranformerList } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";
import { toast } from 'react-toastify';

const fetchVSDList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setCatalogType",
            "gasCalculation/setGasCalculation",
            "gasCalculation/gasCalculationStart",),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
        ),
        switchMap(([actionData, tab1Input]) => {
            const kvaReqd = ""
            const unitSys = tab1Input?.unitSys
            const catalogFilter = actionData.type === setCatalogType.type ? actionData.payload : +tab1Input?.catalogType;
            const postData = [kvaReqd, unitSys, catalogFilter];
            return from(surfaceSer.getSurfEq(postData)).pipe(
                map((data) => SurfaceActions.setSurfaceVSDList({ data }))
            );
        })
    );
}

const fetchSwitchBoardList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setCatalogType",
            "gasCalculation/setGasCalculation",
            "gasCalculation/gasCalculationStart"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
        ),
        switchMap(([actionData, tab1Input]) => {
            const catalogFilter = actionData.type === setCatalogType.type ? actionData.payload : +tab1Input?.catalogType;
            return from(surfaceSer.getSwitchBoard(catalogFilter)).pipe(
                map((data) => SurfaceActions.setSurfaceSwitchBoardList({ payload: data }))
            );
        })

    );
}

const fetchSurfaceVoltageandKva = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("cable/setCableCalculationComplete",
            "motor/setMotorLoadInput",
            "cable/setCableSurfaceVoltage",
            "tubing/setHiddenSurfacePowerFactor",
            "tubing/setHiddenSurfaceEfficiency"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.cable?.cableSurfaceVoltage)),
            state$.pipe(map((state: RootState) => state?.motor?.motor_HPInput)),
            state$.pipe(map((state: RootState) => state?.cable?.cableCalculationComplete)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput))

        ),
        switchMap(([actionData, tab1Input, tab3Input, cableSurfaceVoltage, motor_HPInput, cableCalculationComplete, MotorInput]) => {
            if (cableCalculationComplete) {
                const surfVltge = cableSurfaceVoltage;
                const mtrID = tab1Input?.hiddenMotrID
                const bottmWhole = tab3Input?.bottomHoleTemp
                const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal
                const unitSys = tab1Input?.unitSys
                const hpReq = motor_HPInput?.toString()
                const opFreq = tab3Input?.operatngFreq;
                const powerFactor = tab1Input?.hdnSurface_PwrFactr;
                const efficiency = tab1Input?.hdnSurface_Efficiency;
                const motorLoad = MotorInput?.motorLoad;
                const inputData = [mtrID, unitSys, bottmWhole, bottmWholeUnit, hpReq, opFreq, powerFactor, efficiency, motorLoad];
                store.dispatch(calculateMotorLoadFrequency());
                return from(surfaceSer.getSurfaceEqmnt(inputData, surfVltge)).pipe(
                    map(data => SurfaceActions.setSurfaceKvaAndKw(data))
                )
            }
            return EMPTY
        })
    );
}



const fetchDriveAmps = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/setSurfaceKvaAndKw", "tubing/setHiddenSurfaceSupplyVoltage",),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.KVA))
        ),
        switchMap(([actionData, tab1Input, kvaVal]) => {
            const suplVlt = tab1Input?.hdnSurface_SuplVlt;
            return from(surfaceSer.getDriveAmpsValue(suplVlt, kvaVal)).pipe(
                mergeMap(data => [SurfaceActions.setSurfaceDriveAmps(data),
                SurfaceActions.setSurfaceCalculationComplete(true),
                SurfaceActions.setEnableReport(true)
            ])
            );
        })
    );
}

const saveReportData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/setSurfaceCalculationComplete"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.SurfaceCalculationComplete)),

        ),
        mergeMap(([actionData, surfaceCalcCompleted]) => {
            var projectSaved = sessionStorage.getItem('IsProjectSaved');
            if (surfaceCalcCompleted && projectSaved && projectSaved == 'true') {
                sessionStorage.setItem('IsProjectSaved', 'false');
                return [
                    CalculationActions.saveMainReportData(),
                    CalculationActions.saveWellReportData()
                ]
            }
            else
                return EMPTY;
        })
    );
}

const fetchBasicElectricityCost = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSurfaceCstPrHr",
            "tubing/setHiddenSurfacePowerFactor",
            "tubing/setHiddenSurfaceEfficiency",
            "surface/setSurfaceDriveAmps"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.KVA)),
        ),
        switchMap(([actionData, tab1Input, kvaVal]) => {
            const cstPrHr = tab1Input?.hdnSurface_CstPrHr == null ? 0 : tab1Input?.hdnSurface_CstPrHr
            const pwrFctr = tab1Input?.hdnSurface_PwrFactr == null ? 0 : tab1Input?.hdnSurface_PwrFactr
            const efficiency = tab1Input?.hdnSurface_Efficiency == null ? "null" : tab1Input?.hdnSurface_Efficiency == 0 ? "null" : tab1Input?.hdnSurface_Efficiency;
            return from(surfaceSer.getElectricCostValue(cstPrHr, pwrFctr, kvaVal?.toString(), efficiency)).pipe(
                map(data => SurfaceActions.setSurfaceBasicElectricityCose(data))
            )
        })
    );
}

const fetchHarmonicFiltersAndRecommendations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/setHfInstallationType",
            "surface/setHfEstimatedCurrentAmps",
            "surface/setSurfaceDriveAmps"),
        withLatestFrom(
            // this.surfaceFacade.GetHarmonicFiltersIOs(),
            //     this.surfaceFacade.GetDriveAmps()
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.HarmonicFilter)),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.driveAmps)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        filter(([actionData, harmonicFilterIOs, driveAmps]) => {
            const skipCondition = +(harmonicFilterIOs?.InstallationType?.length) > 0
                && +harmonicFilterIOs?.EstimatedCurrentAmps > 0
                && driveAmps !== null
                && +driveAmps > 0;
            return skipCondition;
        }),
        concatMap(([actionData, harmonicFilterIOs, driveAmps, tab1Input]) => {
            let filterCriteria: HarmonicFiltersFilterCriterias = {
                InstallationType: harmonicFilterIOs.InstallationType === HarmonicFilterInstallationType.ReRun ? 1 : 2,
                EstimatedCurrentAmps: harmonicFilterIOs.EstimatedCurrentAmps,
                VsdAmps: +driveAmps,
                catalogFilter: +tab1Input?.catalogType
            };

            return from(surfaceSer.getHarmonicFiltersAndRecommendations(filterCriteria))
                .pipe(
                    map(data => {
                        return SurfaceActions.setHfRecommendedFilterAndSelectionList(data)
                    }

                    )
                );
        }
        )
    );
}

const fetchEquipments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/fetchEquipments",
            "surface/setPowerField",
            "tubing/setTubingDetails",
            "surface/setWeightField",
            "surface/setSelectedVSD",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.PowerField)),
            state$.pipe(map((stae: RootState) => (stae?.tubing?.tab1Input?.catalogType))),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.WeightField)),
        ),
        switchMap(([actionData, selectedVSDPower, equipmentType, vsdWeight]) => {
            if (selectedVSDPower) {
                return from(surfaceSer.fetchEquipments(selectedVSDPower, equipmentType)).pipe(
                    map(data => {
                        if (data.length === 0) {
                            toast.error('There are no co-related Equipments for Above ESP', {
                                position: 'top-right',
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                style: {
                                    background: '#4CAF50',
                                    color: '#fff'
                                }
                            });
                        }
                        const enrichedData = data.map((item: any) => ({
                            ...item,
                            weight: vsdWeight,
                            text: item?.aalS_Description
                        }));
                        return SurfaceActions.setEquipment(enrichedData)
                    })
                );
            } else {
                return EMPTY;
            }

        })
    );
}

const fetchTransformer = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/fetchTransformers", "tubing/setCatalogType"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => (state?.tubing?.tab1Input))),
        ),
        switchMap(([actionData, tab1Input]) => {
            const { catalogType } = tab1Input;
            const payload = {
                catalogFilter: catalogType
            };
            return from(surfaceSer.fetchTransformer(payload)).pipe(
                map(data => {
                    return setTranformerList(data);
                })
            )
        })
    );
}

const fetchSwitchControllerLoad = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSurfaceSwitchBoard", "surface/setSurfaceSwitchBoardList", "cable/setCableSurfaceVoltage"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.SwitchBoardList)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input?.hiddenSwtchBrd)),
            state$.pipe(map((state: RootState) => state?.cable?.cableSurfaceVoltage)),
        ),
        switchMap(([actionData, switchBoardList, selectedSwitchBoard, surfaceVoltage]) => {
            const selectedSwitchBoardData = switchBoardList.find((x: any) => x?.switchBrdID === selectedSwitchBoard?.toString())
            if (selectedSwitchBoardData && surfaceVoltage) {
                let voltageValue = selectedSwitchBoardData?.voltage?.toString()
                const surfVlt = surfaceVoltage?.toString()
                const surfVltVal = (isNaN(parseFloat(surfVlt))) ? 0 : parseFloat(surfVlt)

                if (surfVlt != "" && voltageValue != "") {
                    let swBrdVltVal = parseFloat(voltageValue)
                    if (swBrdVltVal != 0) {
                        const PrcntSB = +((surfVltVal / swBrdVltVal) * 100).toFixed(1)
                        return of(SurfaceActions.setFetchSwitchControllerLoad(PrcntSB));
                    }
                }
            }
            return EMPTY;
        }
        )
    )
}

const GetPercentageControllerLoadForVSD = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSurfaceVSD", "surface/setSurfaceVSDList", "surface/setSurfaceKvaAndKw"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.VSDList)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input?.hiddenSurfVSD)),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.KVA)),
        ),
        switchMap(([actionData, VSDList, selectedVSD, KVA]) => {
            const selectedVSDPower = VSDList.find((x: any) => x.vsD_ID === selectedVSD?.toString());
            if (selectedVSDPower && KVA) {
                const powerFieldValue = selectedVSDPower?.powerField?.toString();
                const srfPwerVal = parseFloat(powerFieldValue);
                if (srfPwerVal != 0) {
                    const PrcntSB = KVA !== null && srfPwerVal !== 0 ? +((KVA / srfPwerVal) * 100).toFixed(1) : 0;
                    return of(SurfaceActions.setFetchVSDControllerLoad(PrcntSB));
                }
            }
            return EMPTY;
        }
        )
    )

}
const GetSelectedVSD = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/setSurfaceVSDList", "tubing/setTubingDetails"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input?.hiddenSurfVSD)),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.VSDList)),
        ),
        switchMap(([actionData, selectedVSD, VSDList]) => {
            const selectedVSDData = VSDList.find((x: any) => x.vsD_ID === selectedVSD?.toString())
            return of(SurfaceActions.setSelectedVSD(selectedVSDData))
        })
    )
}
const GetSelectedSwitchBoard = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("surface/setSurfaceSwitchBoardList", "tubing/setTubingDetails"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input?.hiddenSwtchBrd)),
            state$.pipe(map((state: RootState) => state?.surfaceEquipment?.SwitchBoardList)),
        ),
        switchMap(([actionData, selectedSwitchBoard, SwitchBoardList]) => {
            const selectedSwitchBoardData = SwitchBoardList.find((x: any) => x?.switchBrdID === selectedSwitchBoard.toString())
            return of(SurfaceActions.setSelectedSwitchBoard(selectedSwitchBoardData))
        })
    )
}



export const surfaceEquipmentEpic = combineEpics(
    fetchVSDList,
    fetchSwitchBoardList,
    fetchSurfaceVoltageandKva,
    fetchDriveAmps,
    saveReportData,
    fetchBasicElectricityCost,
    fetchHarmonicFiltersAndRecommendations,
    fetchEquipments,
    fetchTransformer,
    fetchSwitchControllerLoad,
    GetPercentageControllerLoadForVSD,
    GetSelectedVSD
);